import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { accessToken } from '../../../../configuration/tokenHandling/accessToken';
import { getMarketplaceBackend } from '../../config/pathURL/config';
import { decodeJson, transformRtkQueryError } from '../api';
import type { PaymentMethodRequirement, PaymentMethodRequirementRequest } from './paymentMethodRequirement.types';
import { ApiPaymentMethodRequirementCodec } from './paymentMethodRequirement.types';

export const paymentMethodRequirementApiSlice = createApi({
    reducerPath: 'paymentMethodRequirementApi',
    baseQuery: fetchBaseQuery({
        baseUrl: getMarketplaceBackend(),
        prepareHeaders: headers => {
            const token = accessToken.getAccessToken();
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: builder => ({
        getPaymentMethodRequirement: builder.query<PaymentMethodRequirement, PaymentMethodRequirementRequest>({
            query: ({ accountId, productId, level, resourceIds }) => ({
                url: `/accounts/${accountId}/payment-method-requirements`,
                method: 'POST',
                body: {
                    product_id: productId,
                    ...(level === undefined ? {} : { level }),
                    resource_ids: resourceIds,
                },
            }),
            transformResponse: (response: unknown) => {
                const decoded = decodeJson(ApiPaymentMethodRequirementCodec)(response);
                return { paymentMethodRequired: decoded.payment_method_required };
            },
            transformErrorResponse: response => transformRtkQueryError(response, [401, 403]),
        }),
    }),
});

export const { useGetPaymentMethodRequirementQuery } = paymentMethodRequirementApiSlice;
